<template>
  <component
    :is="link ? 'router-link' : 'div'"
    :to="link || null"
    class="c-cambio-reservation"
    :class="{
      'c-cambio-reservation--inactive': inactive,
      'c-cambio-reservation--current': current
    }"
  >
    <div class="c-cambio-reservation__header" v-if="current">
      Actieve reservatie
    </div>
    <div class="c-cambio-reservation__content">
      <div class="c-cambio-reservation__icon" v-if="icon">
        <o-icon :icon="icon" />
      </div>
      <div class="c-cambio-reservation__text">
        <div class="c-cambio-reservation__label">
          <span :class="{ 'c-cambio-reservation__change': labelChanged }">
            {{ label }}
          </span>
          <span class="c-cambio-reservation__original" v-if="labelChanged">
            {{ labelOriginal }}
          </span>
        </div>
        <div class="c-cambio-reservation__type" v-if="type">
          <span :class="{ 'c-cambio-reservation__change': typeChanged }">
            {{ type }}
          </span>
          <span class="c-cambio-reservation__original" v-if="typeChanged">
            {{ typeOriginal }}
          </span>
        </div>
        <div class="c-cambio-reservation__date" v-if="date">
          <span :class="{ 'c-cambio-reservation__change': dateChanged }">
            {{ date }}
          </span>
          <span class="c-cambio-reservation__original" v-if="dateChanged">
            {{ dateOriginal }}
          </span>
        </div>
      </div>
      <div class="c-cambio-reservation__chevron" v-if="chevron && !inactive">
        <o-icon icon="chevron-right" />
      </div>
    </div>
  </component>
</template>

<script>
export default {
  name: 'OCambioReservation',
  props: {
    icon: {
      type: String,
      default: 'car'
    },
    label: {
      type: String,
      required: true
    },
    labelChanged: {
      type: Boolean,
      default: false
    },
    labelOriginal: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: null
    },
    typeChanged: {
      type: Boolean,
      default: false
    },
    typeOriginal: {
      type: String,
      default: null
    },
    date: {
      type: String,
      default: null
    },
    dateChanged: {
      type: Boolean,
      default: false
    },
    dateOriginal: {
      type: String,
      default: null
    },
    link: {
      type: [String, Object],
      default: null
    },
    inactive: {
      type: Boolean,
      default: false
    },
    current: {
      type: Boolean,
      default: false
    },
    chevron: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss">
.c-cambio-reservation {
  display: block;
}

.c-cambio-reservation__content {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  min-height: 4.8rem;
  padding: 2rem 1.6rem;
}

.c-cambio-reservation__header {
  background: rgba($primary-color, 0.1);
  background: var(--primary-color-light);
  color: $primary-color;
  color: var(--primary-color);
  font-size: 1.2rem;
  font-weight: 600;
  padding: 1.2rem 1.6rem;
  text-transform: uppercase;
}

.c-cambio-reservation__icon {
  background: rgba($primary-color, 0.1);
  border-radius: 50%;
  color: $primary-color;
  color: var(--primary-color);
  display: flex;
  flex: none;
  margin-right: 1.6rem;
  padding: 0.8rem;
}

.c-cambio-reservation__label {
  color: #000;
  font-size: 1.6rem;
  font-weight: 500;
  line-height: 1.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.c-cambio-reservation__type,
.c-cambio-reservation__date {
  color: $gray-700;
  font-size: 1.4rem;
  line-height: 1.6rem;
  margin-top: 0.8rem;
}

.c-cambio-reservation__type {
  margin-top: 1rem;
}

.c-cambio-reservation--inactive {
  .c-cambio-reservation__icon {
    background: rgba($gray-700, 0.1);
    color: $gray-500;
  }

  .c-cambio-reservation__label {
    color: $gray-700;
  }

  .c-cambio-reservation__date,
  .c-cambio-reservation__type {
    color: $gray-500;
  }
}

.c-cambio-reservation--current {
  background: #fff;
  border-radius: $border-radius-small;
  box-shadow: $box-shadow-list;
  margin: 1.6rem 1.6rem 0.8rem;
  overflow: hidden;

  .c-cambio-reservation__content {
    padding: 1.6rem;
  }
}

.c-cambio-reservation__chevron {
  flex: none;
  margin-left: auto;
  padding-left: 1.6rem;
}

.c-cambio-reservation__change {
  background-color: rgba($primary-color, 0.1);
  background-color: var(--primary-color-light);
  border-radius: 0.4rem;
  color: $primary-color;
  color: var(--primary-color);
  display: inline-block;
  padding: 0.2rem 0.4rem;
  vertical-align: middle;
}

.c-cambio-reservation__original {
  color: $gray-500;
  display: none;
  padding: 0.2rem 0.6rem;
  text-decoration: line-through;
  vertical-align: middle;
}

.c-cambio-reservation + .c-cambio-reservation {
  border-top: 0.1rem solid rgba(#000, 0.1);
}
</style>
